import { IConfig } from 'unleash-proxy-client';

export const unleashConfig: IConfig = {
  url: 'https://eu.app.unleash-hosted.com/eubb7001/api/frontend',
  clientKey:
    import.meta.env.VITE_UNLEASH_CLIENT_KEY ??
    'journalsmanager:development.a14b6aa36f4c92eed580ea93ba5a17f4a1115d2aa5f01b8e6df0cd94',
  appName: import.meta.env.VITE_APP_NAME ?? 'journalsmanager'
};
